import React from 'react';
import { IIconProps } from './utils';

export const CloudPending = ({
  fill = 'currentColor', height = 20, width = 20, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 20 20" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M4.16797 15C2.78726 15 1.66797 13.8807 1.66797 12.5C1.66797 11.1894 2.67643 10.1144 3.9597 10.0086C4.07437 9.99909 4.16752 9.90644 4.17224 9.79148C4.28155 7.12676 6.47639 5 9.16797 5C11.334 5 13.1784 6.37736 13.873 8.30403C13.9126 8.41383 14.0316 8.47442 14.1444 8.4445C14.4179 8.37198 14.7051 8.33333 15.0013 8.33333C16.8422 8.33333 18.3346 9.82572 18.3346 11.6667C18.3346 13.5076 16.8422 15 15.0013 15H4.16797Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
  </svg>
);
